<template>
    <v-tooltip
        v-if="$slots.default"
        v-bind="$attrs"
        v-model="show"
        :disabled="disabled"
        :content-class="classContent">
        <template v-slot:activator="{ props }">
            <div
                v-click-outside="onClickOutsideDo"
                :class="classActivator"
                class="u-mouse-pointer"
                v-bind="props"
                @click="onClickSlotDo">
                <slot></slot>
            </div>
        </template>
        <span class="gst-base-tooltip-text">{{ text }}</span>
    </v-tooltip>
</template>
<script>
export default {
    name: 'BaseTooltip',
    inheritAttrs: true,
    props: {
        text: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Boolean,
            default: false,
        },
        classActivator: {
            type: String,
            default: 'gst-base-tooltip__activator d-flex',
        },
        classContent: {
            type: String,
            default: 'gst-base-tooltip',
        },
    },
    data() {
        return {
            show: this.value,
        };
    },
    methods: {
        onClickSlotDo() {
            this.show = !this.show;
        },
        onClickOutsideDo() {
            this.show = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '@scssVariables';

.gst-base-tooltip.v-tooltip__content {
    width: auto !important;
    padding: theme-spacing(4) !important;
    background: theme-color('white') !important;
    color: theme-color('quaternary') !important;
    border-radius: border-radius('xs');
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25) !important;
    opacity: 1 !important;
    max-width: 250px;
}

.gst-base-tooltip__activator {
    margin-left: auto;
}
</style>
